import { useState } from "react";

export function useForceUpdate() {
  const [, setValue] = useState(0);    // integer state
  
  return () => {
    console.warn("FORCEUPDATE! It's ok but should only run in special occations!");
    setValue(value => ++value);     // update the state to force render
  }; 
}
